import AxiosClient from "../../../services/axios.services";

class WorkFlowTaskListServices {
  getWorkFlowTasksList = params =>
    AxiosClient.get(
        "/api/app/Monitor_actividades_responsable_onboarding",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getWorkFlowTaskList = id =>
    AxiosClient.get(
         `/api/app/Monitor_actividades_responsable_onboarding/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveWorkFlowTaskList = data =>
    AxiosClient.post("/api/app/Monitor_actividades_responsable_onboarding/",
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

  editWorkFlowTaskList = (id, data) =>
    AxiosClient.put( `/api/app/Monitor_actividades_responsable_onboarding/${id}/`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

  deleteWorkFlowTaskList = id =>
    AxiosClient.delete( `/api/app/Monitor_actividades_responsable_onboarding/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  dateManage = (data) =>
    AxiosClient.post("/api/app/On_off_boarding_Control_Fechas/", data, {
      headers: { "Content-Type": "application/json" },
    });

  dateManageWorkFlow = (data) =>
    AxiosClient.post("/api/app/On_off_boarding_workflow_Control_Fechas/", data, {
      headers: { "Content-Type": "application/json" },
    });

  saveWorkFlowBlockCheckListPosition = (data) =>
    AxiosClient.post("api/app/On_off_bording_posicion/", data, {
      headers: { "Content-Type": "application/json" },
    });

  estadoActividad = (data) =>
    AxiosClient.post(`/api/app/On_off_bording_estado/`, data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new WorkFlowTaskListServices();
